export const MP_MANIFEST_LS = 'mpManifest'
